import React from 'react'
import { LocaleContext } from '../../context/locale'
import styles from './styles.m.scss'
import config from 'config'
import { FetchErrorMessage } from 'components/fetchErrorMessage'
import { CaseChart } from 'components/caseChart'
import de from 'locales/de.yml'
import fr from 'locales/fr.yml'

const STRINGS = {
  de: de,
  fr: fr
}

export class InfectionsChart extends React.Component {
  // FIXME if a canton is selected which produces errors (because of 404 for example), the following selection of a canton will result in an empty chart (no render?)
  // FIXME the last date in the chart is cut off slightly (but only in FF)
  static contextType = LocaleContext
  /**
   * @param {any} props
   * @param {any} context
   */
  constructor(props, context) {
    super(props, context)

    this.state = {
      daily: null,
      errorMessage: null,
      scaleSteps: null,
      domain: null
    }
    // get daily data
    this.collectDataAndSetState(this.props.kt, this.context)
    this.colo('InfectionsChart constructed')
  }

  /**
   * @param {any} message
   */
  colo(message) {
    if (config.appEnv === 'development') {
      console.log(message)
    }
  }

  /**
   * @param {{ message: any; }} error
   */
  handleError(error) {
    this.colo(error.message)
    this.setState({ errorMessage: error.message })
  }

  /**
   * @param {any[]} data
   */
  calculateDomainAndScaleSteps = data => {
    // FIXME actually fix the following elinst errors
    /* eslint-disable-next-line */
    const _self = this
    const numScaleSteps = 4
    /* eslint-disable-next-line */
    let max = Math.max.apply(
      Math,
      data.map(o => {
        return o[_self.props.variable]
      })
    )
    // round to the nearest 50
    max = Math.ceil(max / 50) * 50
    // round to the nearest 25
    const scaleSteps = Math.ceil(max / numScaleSteps / 25) * 25
    return {
      domain: [0, max],
      scaleSteps: scaleSteps
    }
  }

  /**
   * @param {string} kt
   * @param {string} context
   */
  collectDataAndSetState = (kt, context) => {
    this.getHistoricalData(kt, context)
      .then(data => {
        let domain = this.props.domain
        let scaleSteps = this.props.scaleSteps
        if (this.props.automaticDomainAndScaleSteps === true) {
          // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment (Assignment without declaration)
          ;({ domain, scaleSteps } = this.calculateDomainAndScaleSteps(data))
        }
        this.colo('setting state..')
        this.colo({ data: data, domain: domain, scaleSteps: scaleSteps })
        this.setState({
          daily: data,
          errorMessage: null,
          domain: domain,
          scaleSteps: scaleSteps
        })
      })
      .catch(e => this.handleError(e))
  }

  /**
   * @param {string} kt
   * @param {string} locale
   */
  getHistoricalData = (kt, locale) => {
    this.colo('collecting historical data...')
    const BASE_URL = config.apiBaseUrl
    const API_ENDPOINT = '/api/ccu/get_chart_data/'
    const endpoint = new URL(API_ENDPOINT + kt, BASE_URL)
    endpoint.searchParams.append('lang', locale)
    const url = endpoint

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        this.colo('collected historical data.')
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status + ': ' + response.statusText)
      })
      .then(data => {
        const daily = data.historical_data.filter(d => {
          if (
            d.bydaydate ??
            d.bydaydate !== '' ??
            d.bydaynew ??
            d.bydaynew !== ''
          )
            return d
        })
        return daily
      })
  }

  componentDidMount() {
    // get initial daily data
    this.colo('InfectionsChart mounted')

    // get daily data
    this.collectDataAndSetState(this.props.kt, this.context)
  }

  /**
   * @param {{ kt: any; }} prevProps
   */
  componentDidUpdate(prevProps) {
    this.colo('InfectionsChart updated')
    // this.colo('autotext did update')
    // Typical usage (don't forget to compare props):
    if (this.props.kt !== prevProps.kt) {
      // get daily data
      this.collectDataAndSetState(this.props.kt, this.context)
    }
  }

  render() {
    const localization = STRINGS[this.context]
    this.colo(this.state)
    // Setup content for the default case
    let Content = (
      <>
        {/* situation is HTML, so should be rendered accordingly */}
        {this.state.daily && (
          /* taken from 2020-02-corona-schweizkarte */
          <div className={styles.infectionsChart}>
            {this.props.showAverage && (
              <div className={styles.key}>
                <div className={styles.entry}>
                  <img src={require('images/legende_moving.png')} />
                  <div className={styles.text}>
                    {localization.contentChartLegend}
                  </div>
                </div>
              </div>
            )}
            <CaseChart
              data={this.state.daily}
              prop={this.props.variable}
              scaleSteps={this.state.scaleSteps}
              domain={this.state.domain}
              showAverage={this.props.showAverage}
              isMobile={this.props.isMobile}
            />
          </div>
        )}
        {!this.state.daily && (
          <div className='ui placeholder'>
            {localization.contentLoadingMessage}
          </div>
        )}
      </>
    )

    // show something else in case of an error
    if (this.state.errorMessage) {
      Content = (
        <div className='ui text container'>
          <FetchErrorMessage status={this.state.errorMessage ?? ''} />
        </div>
      )
    }
    this.colo('InfectionsChart rendered')

    return <div>{Content}</div>
  }
}
